const Clock = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3975 7.409V14.2994L18.9911 16.5961M25.8814 14.2994C25.8814 20.6418 20.7399 25.7833 14.3975 25.7833C8.0551 25.7833 2.91357 20.6418 2.91357 14.2994C2.91357 7.95696 8.0551 2.81543 14.3975 2.81543C20.7399 2.81543 25.8814 7.95696 25.8814 14.2994Z"
        stroke="#032806"
        strokeWidth="2.29679"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Clock;
